module.exports = __webpack_public_path__ + "img/concat3.69d6380a.png";